import React, { useState } from 'react';
import { Box, Tooltip, useMediaQuery } from '@chakra-ui/react';
import { MdNoteAdd, MdCheck, MdCancel, MdEdit, MdStar, MdImageNotSupported } from 'react-icons/md';
import { FaBookmark, FaBoxOpen, FaCarCrash } from "react-icons/fa";
import { MdLocalShipping, MdDoNotDisturb, MdMoneyOff, MdErrorOutline } from "react-icons/md";


const MarcadoresVenda = ({ onOptionClick, idVenda, marcadorAtual }) => {
    const [showOptions, setShowOptions] = useState(false);
    const [isMobile] = useMediaQuery("(max-width: 768px)");


    const toggleOptions = () => {
        setShowOptions(!showOptions);
    };

    const buttonCount = 7;

    const totalArc = (5 * Math.PI) / 4;
    const angleStep = buttonCount > 1 ? totalArc / (buttonCount - 1) : 0;

    const baseRadius = isMobile ? 60 : 42;
    const curveRadius = baseRadius * Math.max(1, buttonCount / 6);

    const markerTexts = ["Furo de Estoque", "Venda com Pendências", "Problema no Envio", "Erro de Precificação", "Outros Problemas", "Produto Diferente", "Remover Marcador"];

    const getBgMarcador = () => {
        var color = "gray.300"
        if(!isMobile) {
            if (marcadorAtual == 1) {
                color = "red.300";
            } else if (marcadorAtual == 2) {
                color = "yellow.300";
            } else if (marcadorAtual == 3) {
                color = "gray.400";
            } else if (marcadorAtual == 4) {
                color = "purple.300";
            } else if (marcadorAtual == 5) {
                color = "blue.400";
            } else if (marcadorAtual == 6) {
                color = "orange.300";
            }
        }
        return color;
    }

    const getIconMarcador = () => {
        var icon = "";
        if (marcadorAtual == 1) {
            var icon = <FaBoxOpen color="black" />;
        } else if (marcadorAtual == 2) {
            var icon = <MdDoNotDisturb color="black" />;
        } else if (marcadorAtual == 3) {
            var icon = <MdLocalShipping color="black" />;
        } else if (marcadorAtual == 4) {
            var icon = <MdMoneyOff color="black" />;
        } else if (marcadorAtual == 5) {
            var icon = <MdErrorOutline color="black" />;
        } else if (marcadorAtual == 6) {
            var icon = <MdImageNotSupported color="black" />;
        }else {
            var icon = <FaBookmark fontSize="1.2rem" />
        }
        return icon;
    };



    return (
        <Box position="relative" display="flex" flexDirection="column" alignItems="center">
            {
                isMobile ?
                    (
                        <Tooltip label="Adicionar Marcador">
                            <Box
                                mr={4}
                                //bg="gray.300"
                                bg={getBgMarcador()}
                                w="45px"
                                h="45px"
                                borderRadius="50%"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                cursor="pointer"
                                onClick={toggleOptions}
                                transition="all 0.2s ease-in-out"
                                _hover={{
                                    bg: "gray.400",
                                    transform: "scale(1.2)",
                                }}
                            >
                                {/* <FaBookmark fontSize="1rem" /> */}
                                {getIconMarcador()}
                            </Box>
                        </Tooltip>
                    )
                    :
                    (
                        <Tooltip label="Adicionar Marcador">
                            <Box
                                mr={2}
                                //bg="gray.300"
                                bg={getBgMarcador()}
                                w="35px"
                                h="35px"
                                borderRadius="50%"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                cursor="pointer"
                                onClick={toggleOptions}
                                transition="all 0.2s ease-in-out"
                                _hover={{
                                    bg: "gray.400",
                                    transform: "scale(1.2)",
                                }}
                            >
                                {/* <FaBookmark fontSize="1.2rem" /> */}
                                {getIconMarcador()}
                            </Box>
                        </Tooltip>
                    )
            }
            {showOptions && (
                <Box
                    position="absolute"
                    top={isMobile ? "0%" : "12%"}
                    left="0%"
                    transform="translate(-50%, 0)"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    zIndex={20}
                >
                    {Array.from({ length: buttonCount }).map((_, index) => {
                        const angle = (index - (buttonCount - 1) / 2) * angleStep;
                        const x = -curveRadius * Math.cos(angle);
                        const y = curveRadius * Math.sin(angle);

                        let icon;
                        let color;

                        var indexAux = index + 1;

                        if (indexAux === 1) {
                            icon = <FaBoxOpen color="black" />;
                            color = "red.300";
                        } else if (indexAux === 2) {
                            icon = <MdDoNotDisturb color="black" />;
                            color = "yellow.300";
                        } else if (indexAux === 3) {
                            icon = <MdLocalShipping color="black" />;
                            color = "gray.400";
                        } else if (indexAux === 4) {
                            icon = <MdMoneyOff color="black" />;
                            color = "purple.300";
                        } else if (indexAux === 5) {
                            icon = <MdErrorOutline color="white" />;
                            color = "blue.400";
                        } else if (indexAux === 6) {
                            icon = <MdImageNotSupported color="black" />;
                            color = "orange.300";
                        } else if (indexAux === 7) {
                            icon = <MdCancel color="white" />;
                            color = "black";
                        }

                        return (

                            isMobile ?
                                (
                                    <Tooltip key={index} label={markerTexts[index]}>
                                        <Box
                                            position="absolute"
                                            left={`calc(50% + ${x}px)`}
                                            top={`calc(100% + ${y}px)`}
                                            w="45px"
                                            h="45px"
                                            borderRadius="50%"
                                            bg={color}
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            _hover={{
                                                opacity: 0.3,
                                            }}
                                            onClick={() => onOptionClick(idVenda, indexAux)}
                                        >
                                            {icon}
                                        </Box>
                                    </Tooltip>
                                )
                                :
                                (
                                    <Tooltip key={index} label={markerTexts[index]}>
                                        <Box
                                            position="absolute"
                                            left={`calc(50% + ${x}px)`}
                                            top={`calc(100% + ${y}px)`}
                                            w="30px"
                                            h="30px"
                                            borderRadius="50%"
                                            bg={color}
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            _hover={{
                                                opacity: 0.3,
                                            }}
                                            onClick={() => onOptionClick(idVenda, indexAux)}
                                        >
                                            {icon}
                                        </Box>
                                    </Tooltip>
                                )


                        );
                    })}
                </Box>
            )}
        </Box>
    );
};

export default MarcadoresVenda;
